import React, { useState, useEffect } from "react";
import { Layout, Menu, Dropdown, Badge, Button } from "antd";
import {
  DashboardOutlined,
  LinkOutlined,
  HomeOutlined,
  FileTextOutlined,
  HeartOutlined,
  AlertOutlined,
  LogoutOutlined,
  BellOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  DatabaseFilled,
} from "@ant-design/icons";
import "../css/adminLayout.css";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

const { Header, Sider, Content } = Layout;

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user")) || { name: "Admin" };

  const toggle = () => setCollapsed(!collapsed);

  // Sidebar menu items
  const menuItems = [
    { key: "/dashboard", icon: <DashboardOutlined />, label: "Dashboard" },
    // {
    //   key: 'homepage',
    //   icon: <HomeOutlined />,
    //   label: 'Home',
    //   children: [{ key: '/dashboard/banner', label: 'Banner' }],
    // },
    {
      key: "aboutus",
      icon: <AlertOutlined />,
      label: "About Us",
      children: [
        { key: "/dashboard/journey", label: "Timeline" },
        { key: "/dashboard/management", label: "Management" },
      ],
    },
    {
      key: "jobs",
      icon: <LinkOutlined />,
      label: "Career",
      children: [
        { key: "/dashboard/application-jobs", label: "Application Jobs" },
        { key: "/dashboard/career", label: "Jobs" },
        { key: "/dashboard/category-career", label: "Category Jobs" },
      ],
    },

    {
      key: "ourbusiness",
      icon: <AlertOutlined />,
      label: "Our Business",
      children: [{ key: "/dashboard/awards", label: "Awards" }],
    },
    {
      key: "/dashboard/government-doc",
      icon: <FileTextOutlined />,
      label: "Government Document",
    },
    {
      key: "/dashboard/investor-doc",
      icon: <FileTextOutlined />,
      label: "Investor Document",
    },
    { key: "/dashboard/news", icon: <LinkOutlined />, label: "News" },
    { key: "/dashboard/csr", icon: <HeartOutlined />, label: "CSR" },
    // {
    //   key: 'masterdata',
    //   icon: <DatabaseFilled />,
    //   label: 'Master Data',
    //   children: [
    //     { key: '/dashboard/category-career', label: 'Category Jobs' },
    //     { key: '/dashboard/category-career', label: '' },
    //   ],
    // },
  ];

  // Handle sidebar navigation
  const handleSidebarClick = ({ key }) => {
    navigate(key);
  };

  // Auto-open submenu if current path matches child
  useEffect(() => {
    const path = location.pathname;
    const parentKey = menuItems.find((item) =>
      item.children?.some((child) => child.key === path),
    )?.key;
    if (parentKey) setOpenKeys([parentKey]);
  }, [location.pathname]);

  const onOpenChange = (keys) => setOpenKeys(keys);

  // User dropdown menu
  const userMenu = (
    <Menu
      onClick={({ key }) => {
        if (key === "profile") navigate("/dashboard/profile");
        if (key === "logout") {
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          navigate("/");
        }
      }}
      items={[
        { label: "Profile", key: "profile", icon: <UserOutlined /> },
        { label: "Logout", key: "logout", icon: <LogoutOutlined /> },
      ]}
    />
  );

  const notifications = [
    { id: 1, message: "New application received" },
    { id: 2, message: "Article approved" },
  ];

  const notificationMenu = (
    <Menu
      items={notifications.map((n) => ({
        key: n.id,
        label: n.message,
      }))}
    />
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Header */}
      <Header
        style={{
          background: "#ec4899",
          padding: "0 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "#fff",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <Button
            type="text"
            onClick={toggle}
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            style={{ color: "#fff" }}
          />
          <img
            src="/images/logo-white.png"
            alt="Bolde Logo"
            style={{ height: 32, objectFit: "contain" }}
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
          <Dropdown overlay={notificationMenu} placement="bottomRight">
            <Badge count={notifications.length} size="small">
              <BellOutlined
                style={{ fontSize: 18, color: "#fff", cursor: "pointer" }}
              />
            </Badge>
          </Dropdown>

          <Dropdown
            overlay={userMenu}
            placement="bottomRight"
            trigger={["click"]}
          >
            <span style={{ color: "#fff", fontWeight: 500, cursor: "pointer" }}>
              <UserOutlined style={{ marginRight: 8 }} />
              {user.name}
            </span>
          </Dropdown>
        </div>
      </Header>

      {/* Sider & Content */}
      <Layout>
        <Sider
          width={220}
          collapsible
          collapsed={collapsed}
          trigger={null}
          style={{ backgroundColor: "white" }}
        >
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            items={menuItems}
            onClick={handleSidebarClick} // <-- hanya navigasi
            style={{ backgroundColor: "white", height: "100%", borderRight: 0 }}
          />
        </Sider>

        <Content style={{ margin: 16, padding: 16, backgroundColor: "#fff" }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
